import { customScrollbar, tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const DropdownContent = styled.div`
	opacity: 0;
	position: absolute;
	width: 100%;
	z-index: 3;
	visibility: hidden;
	top: 36px;
	left: 0px;
	border: 1px solid ${tokens.color_gray_medium};
	background-color: ${tokens.color_gray_light};
	border-radius: 6px;
	display: flex;
	flex-direction: column;
	gap: 10px;
	overflow-y: auto;
	max-height: 140px;
	padding: 8px 14px;
	${customScrollbar};
`;

export const Wrapper = styled.div`
	position: relative;
	display: inline-block;
	width: 100%;
	border: 1px solid ${tokens.color_gray_medium};
	background-color: ${tokens.color_gray_light};
	border-radius: 6px;
	padding: 8px 14px;

	&:hover ${DropdownContent} {
		opacity: 1;
		visibility: visible;
	}
`;

export const Content = styled.div`
	display: flex;
	text-align: center;
	justify-content: space-between;
	color: ${tokens.color_gray_dark};
`;
